<template>
  <Loading :active="isLoading" style="z-index: 9000"></Loading>

  <Toast :baseZIndex="1009" position="bottom-left"></Toast>
  <ConfirmDialog name="confirmDialog"></ConfirmDialog>

  <div :class="containerClass" @click="onWrapperClick" v-if="!captchaError">
    <AppTopBar @menu-toggle="onMenuToggle" v-if="isLogin" />

    <transition name="layout-sidebar">
      <div
        :class="sidebarClass"
        @click="onSidebarClick"
        v-if="isSidebarVisible() && isLogin"
      >
        <div class="layout-logo">
          <router-link to="/menu">
            <div class="p-d-flex p-align-center p-justify-center">
              <span
                style="font-family: 'Ropa Sans';font-size: 2rem; font-weight: bold;"
                class="title"
                >HRD Smart</span
              >
            </div>
          </router-link>
        </div>

        <AppProfile />
        <AppMenu :model="menu" @menuitem-click="onMenuItemClick" />
      </div>
    </transition>

    <div :class="isLogin ? 'layout-main' : ''">
      <router-view />
    </div>

    <AppFooter v-if="isLogin" />
    <CookieLaw />
  </div>
  <div v-else class="captcha-error">
    <i class="pi pi-info-circle" style="font-size: 2rem;"></i>
    พบปัญหาใน Recaptcha ไม่สามารถให้คุณเข้าถึงระบบได้
    กรุณาเปลี่ยนการเชื่อมต่อและลองใหม่ภายหลัง - {{ captchaError }}
  </div>
</template>

<script lang="ts">
import {
  defineComponent,
  watch,
  computed,
  ref,
  onBeforeUpdate,
  onMounted,
} from "vue";
import { usePlugin } from "@/plugins";
// import AppHeader from "@/components/AppHeader.vue";
import ConfirmDialog from "primevue/confirmdialog";
// import Toast from "primevue/toast";
import { useConfirm } from "primevue/useconfirm";
import { useToast } from "primevue/usetoast";
// import { useTitle } from "@vueuse/core";
import { useRouter, useRoute } from "vue-router";
// import { useStore } from "vuex";
// import AppMenu from "./components/AppMenu.vue";
import menuData from "./menu";
import AppTopBar from "./AppTopbar.vue";
import AppProfile from "./AppProfile.vue";
import AppMenu from "./AppMenu.vue";
import AppFooter from "./AppFooter.vue";
import Loading from "vue3-loading-overlay";
import CookieLaw from "@/components/CookieLaw.vue";
import "vue3-loading-overlay/dist/vue3-loading-overlay.css";

import { useReCaptcha } from "vue-recaptcha-v3";
import { ValidateCaptchaRequest, ValidateCaptchaResponse } from "./types";

export default defineComponent({
  name: "App",
  components: {
    AppTopBar: AppTopBar,
    AppProfile: AppProfile,
    AppMenu: AppMenu,
    ConfirmDialog,
    Loading,
    AppFooter: AppFooter,
    CookieLaw,
  },
  setup() {
    const { setupPlugin } = usePlugin();
    setupPlugin(useToast(), useRouter(), useRoute(), useConfirm());
    const {
      route,
      useState,
      useSessionState,
      setIdentity,
      getUserProfile,
      axios,
    } = usePlugin();

    const recaptcha = useReCaptcha();
    const captchaError = ref("");

    const sessionState = useSessionState();
    const layoutMode = ref("static");
    const staticMenuInactive = ref(false);
    const overlayMenuActive = ref(false);
    const mobileMenuActive = ref(false);
    const layoutColorMode = ref("dark");
    watch(
      () => route,
      () => {
        overlayMenuActive.value = false;
        mobileMenuActive.value = false;
        // toast.removeAllGroups();
      }
    );
    const menu = computed(() => menuData(sessionState.value.profile));
    const menuClick = ref(false);

    const isLoading = computed(
      () => sessionState.value.loadingCount > 0 || false
    );
    const state = useState();
    const isLogin = computed(
      () =>
        state.value.authentication.token != null &&
        state.value.authentication.token != ""
    );

    const isDesktop = () => window.innerWidth > 1024;
    const isSidebarVisible = () => {
      if (isDesktop()) {
        if (layoutMode.value === "static") return !staticMenuInactive.value;
        else if (layoutMode.value === "overlay") return overlayMenuActive.value;
        else return true;
      } else {
        return true;
      }
    };
    const onWrapperClick = () => {
      if (!menuClick.value) {
        overlayMenuActive.value = false;
        mobileMenuActive.value = false;
      }
      menuClick.value = false;
    };

    const onMenuToggle = (event: Event) => {
      menuClick.value = true;
      if (isDesktop()) {
        if (layoutMode.value === "overlay") {
          if (mobileMenuActive.value === true) {
            overlayMenuActive.value = true;
          }
          // overlayMenuActive.value = !overlayMenuActive.value;
          mobileMenuActive.value = false;
        } else if (layoutMode.value === "static") {
          staticMenuInactive.value = !staticMenuInactive.value;
        }
      } else {
        mobileMenuActive.value = !mobileMenuActive.value;
      }
      event?.preventDefault();
    };

    const onSidebarClick = () => (menuClick.value = true);
    const onMenuItemClick = (event: any) => {
      if (event.item && !event.item.items) {
        overlayMenuActive.value = false;
        mobileMenuActive.value = false;
      }
    };
    const onLayoutChange = (inputLayout: string) => {
      layoutMode.value = inputLayout;
    };
    const onLayoutColorChange = (inputLayout: string) => {
      layoutColorMode.value = inputLayout;
    };
    const containerClass = computed(() => {
      return [
        "layout-wrapper",
        {
          "layout-overlay": layoutMode.value === "overlay",
          "layout-static": layoutMode.value === "static",
          "layout-static-sidebar-inactive":
            staticMenuInactive.value && layoutMode.value === "static",
          "layout-overlay-sidebar-active":
            overlayMenuActive.value && layoutMode.value === "overlay",
          "layout-mobile-sidebar-active": mobileMenuActive.value,
          "p-input-filled": false,
          "p-ripple-disabled": true,
          // "p-input-filled": this.$appState.inputStyle === "filled",
          // "p-ripple-disabled": this.$primevue.ripple === false,
        },
      ];
    });
    const addClass = (element: any, className: string) => {
      if (element.classList) element.classList.add(className);
      else element.classList += " " + className;
    };
    const removeClass = (element: any, className: string) => {
      if (element.classList) element.classList.remove(className);
      else
        element.className = element.className.replace(
          new RegExp(
            "(^|\\b)" + className.split(" ").join("|") + "(\\b|$)",
            "gi"
          ),
          " "
        );
    };

    const sidebarClass = computed(() => {
      return [
        "layout-sidebar",
        {
          "layout-sidebar-dark": layoutColorMode.value === "dark",
          "layout-sidebar-light": layoutColorMode.value === "light",
        },
      ];
    });

    // const logoTextClass = computed(() =>
    // 	layoutColorMode.value === "dark"
    // 		? "logo-text logo-text-dark"
    // 		: "logo-text logo-text-light"
    // );

    onMounted(async () => {
      //setup token and query master data.
      sessionState.value.loadingCount = 0; //fix loading count
      setIdentity();
      getUserProfile();

      //recaptcha
      await recaptcha?.recaptchaLoaded();
      const token = await recaptcha?.executeRecaptcha("loaded");
      //TODO: Sent token to authen with server.
      var result = await axios.post<ValidateCaptchaResponse>(
        "api/v1/services/captcha",
        {
          token: token,
        } as ValidateCaptchaRequest
      );
      captchaError.value = result.data.success
        ? ""
        : JSON.stringify(result.data["error-codes"]);
      // captchaError.value = ""; //Remove on deploy
    });

    onBeforeUpdate(() => {
      if (mobileMenuActive.value)
        addClass(document.body, "body-overflow-hidden");
      else removeClass(document.body, "body-overflow-hidden");
    });

    return {
      layoutMode,
      layoutColorMode,
      staticMenuInactive,
      overlayMenuActive,
      mobileMenuActive,
      menu,
      menuClick,

      isLoading,
      isLogin,

      onWrapperClick,
      onMenuToggle,
      onSidebarClick,
      onMenuItemClick,
      onLayoutChange,
      onLayoutColorChange,
      isSidebarVisible,

      addClass,
      removeClass,

      containerClass,
      sidebarClass,
      captchaError,
      // logo,
      // logoTextClass,
      // logo,
    };
  },
});
</script>

<style lang="scss">
@import "./App.scss";

@import "../node_modules/primevue/resources/themes/saga-blue/theme.css";
@import "../node_modules/primevue/resources/primevue.min.css";
@import "../node_modules/primeflex/primeflex.css";
@import "../node_modules/primeicons/primeicons.css";
@import "../node_modules/vue2-animate/dist/vue2-animate.min.css";
@import "../node_modules/@syncfusion/ej2/material.css";

.logo-text {
  font-size: 1.2rem;
  font-weight: bold;
}

.logo-text-light {
  color: #333;
}

.logo-text-dark {
  color: white;
}

.layout-login {
  padding: 5rem;
}

.layout-loading {
  position: fixed;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.5);
}

.layout-loading-enter-active,
.layout-loading-leave-active {
  transition: height 0.5s ease;
}

.layout-loading-enter-from,
.layout-loading-leave-to {
  height: 0;
}

.progress-wrapper {
  position: absolute;
  top: 50vh;
  left: 50vw;
  font-size: 50px;
  color: white;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  z-index: 2000;
}
.title {
  color: white;
}

.captcha-error {
  font-size: 2rem;
  color: red;
  font-weight: bold;
  margin: 5rem;
  padding: 5rem;
}
</style>
